(function () {
  const root = document.querySelector('[data-ts-longform]');
  if (!root) return;

  root.querySelectorAll('[data-ts-scroll-offer]').forEach((button) => {
    button.addEventListener('click', (event) => {
      const target = root.querySelector('#ts-offer');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      window.history.replaceState(null, '', '#ts-offer');
    });
  });

  root.querySelectorAll('[data-ts-purchase-option]').forEach((option) => {
    option.addEventListener('change', () => {
      root.querySelectorAll('[data-ts-purchase-card]').forEach((card) => {
        card.classList.toggle('is-selected', card.contains(option));
      });
    });
  });

  const orderBox = root.querySelector('[data-ts-order-box]');
  const checkoutButton = orderBox && orderBox.querySelector('[data-ts-checkout-button]');
  if (orderBox && checkoutButton) {
    checkoutButton.addEventListener('click', async () => {
      const button = checkoutButton;
      if (button) {
        button.disabled = true;
        button.textContent = 'Taking you to checkout…';
      }

      try {
        const selectedOption = orderBox.querySelector('[data-ts-purchase-option]:checked');
        const body = new URLSearchParams({
          id: orderBox.dataset.variantId || '',
          quantity: selectedOption ? selectedOption.dataset.quantity || '1' : '1',
        });
        if (selectedOption && selectedOption.dataset.sellingPlan) {
          body.set('selling_plan', selectedOption.dataset.sellingPlan);
        }

        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body,
        });

        if (!response.ok) throw new Error('Unable to add the selected offer to checkout.');
        window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
      } catch (error) {
        if (button) {
          button.disabled = false;
          button.textContent = 'Continue to Secure Checkout';
        }
        window.alert(error.message || 'We could not start checkout. Please try again.');
      }
    });
  }
})();
